// Centralised, distinct color palette for every workflow/entity status across
// the platform. Every key resolves to a visually distinct hex — no two states
// share a hue family. Use these instead of redefining ad-hoc palettes in
// individual pages so the visual language stays consistent and unambiguous.
//
// Hue map (for review):
//   emerald  (#10B981)  → operational / approved
//   indigo   (#6366F1)  → executed (distinct from approved)
//   sky      (#0EA5E9)  → audited / informational
//   amber    (#F59E0B)  → warning / in_review
//   teal     (#14B8A6)  → closing (distinct from amber)
//   red      (#EF4444)  → in_arrears
//   fuchsia  (#C026D3)  → dividend_overdue (distinct from arrears red)
//   rose     (#E11D48)  → rejected
//   slate    (#94A3B8)  → pending (light grey)
//   stone    (#78716C)  → dormant (warm grey, distinct from pending)
//   zinc-700 (#3F3F46)  → cancelled (darker neutral, distinct from draft)
//   slate-100 (#94A3B8) → draft
//   gray-900 (#111827)  → dissolved (near-black, terminal)

export const ENTITY_STATUS_META = {
  active:           { color: '#10B981', tint: '#10B98114', label: 'Operational' },
  audited:          { color: '#0EA5E9', tint: '#0EA5E914', label: 'Audited' },
  warning:          { color: '#F59E0B', tint: '#F59E0B14', label: 'Warning' },
  in_arrears:       { color: '#EF4444', tint: '#EF444414', label: 'In Arrears' },
  dividend_overdue: { color: '#C026D3', tint: '#C026D314', label: 'Dividend Overdue' },
  closing:          { color: '#14B8A6', tint: '#14B8A614', label: 'Closing' },
  pending:          { color: '#94A3B8', tint: '#94A3B814', label: 'Pending' },
  dormant:          { color: '#78716C', tint: '#78716C14', label: 'Dormant' },
  dissolved:        { color: '#111827', tint: '#11182714', label: 'Dissolved' },
};

// Workflow / change-request status palette — Tailwind class pairs so cards
// keep their tonal background + foreground readability without inline styles.
export const WORKFLOW_STATUS_META = {
  in_review: { cls: 'bg-amber-50 text-amber-700 border-amber-200',     label: 'In review' },
  approved:  { cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', label: 'Approved' },
  executed:  { cls: 'bg-indigo-50 text-indigo-700 border-indigo-200',   label: 'Executed' },
  rejected:  { cls: 'bg-rose-50 text-rose-700 border-rose-200',         label: 'Rejected' },
  draft:     { cls: 'bg-slate-100 text-slate-600 border-slate-200',     label: 'Draft' },
  cancelled: { cls: 'bg-zinc-200 text-zinc-700 border-zinc-300',        label: 'Cancelled' },
};
